
define('paychex.app.messages/data/RemoteGetPNGSSOMessages',['com/paychex/widget/messageBoard/dto/GetPngSsoMessagesRequest'], function(GetPngSsoMessagesRequest) {
    'use strict';

    return {
        retryCount: 2,
        callType: 'remote',
        operation: 'getPngSSOMessages',
        destination: 'messageBoardRemote',
        baseUrl: '/landing_remote/do/json/',
        objectMapperOpts: {skipDecode: true},
        generateOperationParams: function(params, data) {
            var request = new GetPngSsoMessagesRequest();
            if (data && data.clientIds !== ''){
                request.ClientIds = data.clientIds;
                if (data.mode !== ''){
                    request.mode = data.mode;
                }
                return request;
            }
        }
    };
});

